import axios from 'axios'
import baseUrl from './base-url'

export default function({ state }, { url, query }) {
    let hasHandoff = url.includes('handoff_token')
    if (query)
        url = url + '?' + Object.keys(query).map((q) => (q + '=' + query[q])).join('&')

    // if handoff_token is present 
    // then don't use credentials (withCredentials)
    return axios.delete(baseUrl + url, {
            withCredentials: !hasHandoff
        })
        .then((response) => {
            return response.data
        })
        .catch((error) => {
            // console.log('post error', error)
            // console.log('error', JSON.stringify(error.response.data, null, 4))
            throw error.response.data
        })
}
